require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./service-develop-ux-design-process.json") })
        }
      }, "path---service-develop-ux-design-process");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---service-develop-ux-design-process!./.cache/json/service-develop-ux-design-process.json
// module id = 904
// module chunks = 231608221292675